'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BADGE_COLORS = exports.BADGE_COLORS = {
  calypso: 'is--color-calypso',
  sorbet: 'is--color-sorbet',
  lorax: 'is--color-lorax',
  marigold: 'is--color-marigold',
  'candy-apple': 'is--color-candy-apple',
  norman: 'is--color-norman',
  thunderdome: 'is--color-thunderdome',
  oz: 'is--color-oz'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/badge/BadgeConstants.js
// module id = 304
// module chunks = 0